module.exports = __webpack_public_path__ + "media/integrations/ebay-cc7a56f4.svg";